/** Stammdaten-API — Einheiten und Kategorien (lesend). */

import { apiJson } from '../auth/api-client';
import type { Einheit, Kategorie } from './types';

export function ladeEinheiten(): Promise<Einheit[]> {
  return apiJson<Einheit[]>('/stammdaten/einheiten');
}

export function ladeKategorien(): Promise<Kategorie[]> {
  return apiJson<Kategorie[]>('/stammdaten/kategorien');
}
